/* Arboron — page de présentation. Converti depuis la maquette Claude Design.
   Reprend : bascule FR/EN, révélations au scroll, simulateur de critères,
   bande de header au scroll, boucle vidéo en fondu.

   Le français n'est pas dupliqué ici : il est écrit dans le template et relevé
   au chargement (RETOUR_FR). Ce fichier ne porte que la traduction anglaise. */
(function () {
  'use strict';

  var EN = {
    nav_contact: 'Contact',
    nav_steps: 'Our criteria',
    nav_water: 'Water',
    nav_why: 'Our stand',
    nav_status: 'In development',
    scroll_label: 'Scroll',
    s1_num: '01',
    s1_eyebrow: 'What we do',
    hero_title: 'Everyday products, rethought.',
    hero_sub: 'Well designed, with a low and documented impact, at the fairest price, with our design choices and our prices laid out in detail. We start with water, a bottle that filters what comes out of the tap.',
    s2_num: '03',
    s2_eyebrow: 'Our starting point',
    s2_title: 'Better water, everywhere.',
    s2_body: "The water we drink isn't as good as it should be. Closely monitored at the source, it gets re-contaminated on its way to us. Tap and bottled water alike contain contaminants that harm our health over time. Yet all it takes is to filter it the moment you drink it. That is what our first product does: a bottle that removes from tap water what shouldn't be in it, wherever you go.",
    cmp_today_label: 'Current consumption',
    cmp_answer_label: 'Our answer',
    cmp_status_dev: 'In development',
    cmp_status_soon: 'Coming',
    b_price_v: '≈ €0.20–0.40', b_price_n: '/L',
    t_price_v: '≈ €0.005', t_price_n: '/L',
    sol_price_v: '≈ €0.07', sol_price_n: '/L · estimate',
    cmp_now1_t: 'Bottled water',
    b_f1_t: 'Plastic pollution',
    b_f1_v: '≈ 1 million bottles sold every minute worldwide, only a minority recycled.',
    b_f1_s: 'Euromonitor, 2017',
    b_f5_t: 'Transport and single use',
    b_f5_v: 'Bottling water, hauling it hundreds of kilometres, then discarding it after a single use: a carbon footprint far greater than tap water.',
    b_f5_s: 'ADEME',
    b_f2_t: 'Nanoplastics',
    b_f2_v: '≈ 240,000 plastic fragments per litre, around 90% of them nanoplastics — including PET from the bottle itself.',
    b_f2_s: 'Columbia University, PNAS, 2024',
    b_f4_t: 'Agricultural contamination',
    b_f4_v: 'Pesticides seep into soils and reach the groundwater that bottled water is drawn from: residues have been detected in some bottled waters.',
    b_f4_s: 'Anses, 2024 ; UFC-Que Choisir, 2026',
    b_f3_t: 'Cost',
    b_f3_v: '≈ €220 per person a year at 2 litres a day. The same water from the tap: under €4.',
    b_f3_s: 'Estimate at average prices; SISPEA 2023',
    cmp_sol1_t: 'Filtering bottle',
    cmp_sol1_lead: 'The answer: filtered tap water, everywhere. For that, our bottle has to deliver on every front:',
    b_e1_t: 'Filtration performance',
    b_e1_v: 'Hold back the contaminants that matter.',
    b_e2_t: 'Ease of use',
    b_e2_v: 'Simple and pleasant, every day.',
    b_e3_t: 'Refill cost',
    b_e3_v: 'A replaceable filter at a fair price.',
    b_e4_t: 'Lifespan',
    b_e4_v: 'Robust, built to last.',
    b_e5_t: 'Eco-design',
    b_e5_v: 'Less material, less waste.',
    cmp_now2_t: 'Tap water',
    t_f1_t: 'The cocktail effect',
    t_f1_v: 'Limits are set substance by substance; the effects of their mixtures remain poorly understood.',
    t_f1_s: 'Anses',
    t_f2_t: 'Ageing networks',
    t_f2_v: 'Treated at the plant, water can pick up contamination on its way to your tap: old pipes and plumbing, lead in the oldest networks.',
    t_f2_s: 'French Ministry of Health',
    t_f3_t: 'Local pollutants',
    t_f3_v: 'PFAS, pesticides or nitrates depending on the area.',
    t_f3_s: 'Anses; IARC, 2023',
    t_f4_t: 'Taste and smell',
    t_f4_v: 'Chlorine can leave an unpleasant taste or smell.',
    t_f5_t: 'Limescale',
    t_f5_v: 'In hard-water areas, it scales up appliances and pipes.',
    cmp_sol2_t: 'Home filtration',
    cmp_next_label: 'And next',
    cmp_next_b: 'The same standard, extended to all the water in the home. After the bottle, our work turns to home filtration.',
    cc_eyebrow: 'Where we start',
    cc_title: 'Why the bottle first.',
    cc_r1_t: 'The simplest way in',
    cc_r1_b: 'Water filtration is still little known. A bottle fits into daily life with no installation or works: you discover the subject by using it.',
    cc_r2_t: 'A necessary replacement',
    cc_r2_b: 'Of our everyday ways of drinking water, the disposable bottle is the heaviest on the environment: plastic, transport, single use. It is also the most expensive. It carries contaminants of its own, without solving those of the tap. Replacing it with filtered tap water addresses all of it.',
    cc_r3_t: 'The most reasonable for us',
    cc_r3_b: 'For a young company, it is the simplest product in its category to take on, and the least costly to launch. That is what lets us see it through, and then fund the development of more demanding products.',
    s_demo_num: '02',
    s_demo_eyebrow: 'Our criteria',
    s_demo_title: 'Every product must first justify itself.',
    s_demo_lead: 'Each of our products must meet these four criteria before it is designed, to make sure it earns its place.',
    g1_t: 'Genuinely useful',
    g1_b: 'Answers a real need, not a superfluous comfort.',
    g2_t: 'Healthy',
    g2_b: 'Safe and good for the person. Non-controversial materials.',
    g3_t: 'Responsible',
    g3_b: 'Eco-designed to last. No feature whose environmental cost outweighs its usefulness.',
    g4_t: 'Accessible',
    g4_b: 'Within reach of the many: at the fairest price, designed for simple everyday use.',
    s3_num: '04',
    s3_eyebrow: 'Why Arboron exists',
    s3_manifesto: 'Where we stand',
    st1: 'Consuming better',
    st1_s: 'Sober products, built to last: less material, no feature whose environmental cost outweighs its usefulness.',
    st2: 'For everyone',
    st2_s: 'No needless extra costs, no superfluous packaging, no excessive marketing. A slim margin, for a price that is accessible and justified.',
    st3: 'In full transparency',
    st3_s: 'Margin, manufacturing cost, environmental footprint: broken down product by product. Every design choice, explained.',
    partners_email: 'brice.g@arboron.co',
    footer_loc: 'Arboron',
    footer_contact_label: 'Contact',
    footer_legal: '© 2026 Arboron. All rights reserved.'
  };

  /* candidats du simulateur : jamais présents dans le DOM, donc écrits ici
     dans les deux langues */
  var SIM = {
    fr: [
      { name: 'Un produit de qualité, accessible', verdict: 'Conçu', stop: -1, type: 'ok' },
      { name: 'Un gadget superflu', verdict: 'Rejeté — critère 01', stop: 0, type: 'ko' },
      { name: 'Un produit de qualité, mais inaccessible', verdict: 'Rejeté — critère 04', stop: 3, type: 'ko' }
    ],
    en: [
      { name: 'A quality, accessible product', verdict: 'Made', stop: -1, type: 'ok' },
      { name: 'A superfluous gadget', verdict: 'Rejected — criterion 01', stop: 0, type: 'ko' },
      { name: 'A quality product, but inaccessible', verdict: 'Rejected — criterion 04', stop: 3, type: 'ko' }
    ]
  };

  var FR = {};          // relevé depuis le template au chargement
  var lang = 'fr';
  var simTimers = [];
  var simOn = false;
  var simCi = 0;
  var simIO = null;
  var revealIO = null;

  /* ---------- langue ---------- */

  function captureFr() {
    var nodes = document.querySelectorAll('[data-i18n]');
    for (var i = 0; i < nodes.length; i++) {
      FR[nodes[i].getAttribute('data-i18n')] = nodes[i].textContent;
    }
  }

  function applyLang() {
    var d = lang === 'en' ? EN : FR;
    var nodes = document.querySelectorAll('[data-i18n]');
    for (var i = 0; i < nodes.length; i++) {
      var k = nodes[i].getAttribute('data-i18n');
      if (d[k] != null) nodes[i].textContent = d[k];
    }
    var btns = document.querySelectorAll('.langbtn');
    for (var j = 0; j < btns.length; j++) {
      btns[j].classList.toggle('on', btns[j].getAttribute('data-lang') === lang);
    }
    try { document.documentElement.lang = lang; } catch (e) {}
  }

  function setLang(l) {
    if (l !== 'fr' && l !== 'en') return;
    lang = l;
    try { localStorage.setItem('arboron_lang', l); } catch (e) {}
    applyLang();
    armReveal();
    armCriteria();
  }

  function armLangButtons() {
    var btns = document.querySelectorAll('.langbtn');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        setLang(this.getAttribute('data-lang'));
      });
    }
  }

  /* ---------- header : bande blanche au scroll ---------- */

  function armScroll() {
    try {
      var hdr = document.getElementById('hdr');
      var sentinel = document.getElementById('top-sentinel');
      if (!hdr || !sentinel || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          hdr.classList.toggle('hdr-scrolled', !e.isIntersecting);
        });
      }, { threshold: 0 }).observe(sentinel);
    } catch (e) {}
  }

  /* ---------- vidéo de la section eau : boucle en fondu ---------- */

  function crossfadeLoop(aId, bId) {
    try {
      var a = document.getElementById(aId);
      var b = document.getElementById(bId);
      /* le markup pose preload="none" pour ne rien telecharger sur telephone.
         Arrive ici, on a decide de jouer : on rouvre le prechargement pour que
         la seconde video soit prete a la couture de la boucle. */
      var prep = function (v) { if (v) { v.muted = true; v.playsInline = true; v.preload = 'auto'; } };
      prep(a); prep(b);
      var play = function (v) {
        if (!v) return;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };

      if (!a || !b) { play(a || b); return; }

      var A = a, B = b;
      A.style.opacity = 1; B.style.opacity = 0;
      var FADE = 1.2; // secondes de fondu à la couture de la boucle
      var swapping = false;

      var tick = function () {
        if (swapping || !A.duration || isNaN(A.duration)) return;
        if (A.duration - A.currentTime <= FADE) {
          swapping = true;
          try { B.currentTime = 0; } catch (e) {}
          play(B);
          B.style.opacity = 1;
          A.style.opacity = 0;
          setTimeout(function () {
            try { A.pause(); } catch (e) {}
            var t = A; A = B; B = t;
            swapping = false;
          }, FADE * 1000);
        }
      };
      a.addEventListener('timeupdate', tick);
      b.addEventListener('timeupdate', tick);

      play(A);
      [250, 800, 1800].forEach(function (t) { setTimeout(function () { play(A); }, t); });
      var kick = function () { play(A); };
      ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function (evt) {
        window.addEventListener(evt, kick, { once: true, passive: true });
      });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) play(A);
      });
    } catch (e) {}
  }

  /* Deux verrous avant de toucher aux 2,66 Mo de video : l'ecran doit etre assez
     large pour qu'elle soit visible (sous 820px le CSS la masque), et la section
     doit approcher du champ de vision. Tant que l'un des deux manque, rien n'est
     telecharge. Le changement de largeur est ecoute : passer en plein ecran ou
     tourner le telephone declenche le chargement si la section est en vue. */
  function armHeroVideos(aId, bId) {
    try {
      var frame = document.querySelector('.media-frame');
      if (!frame) return;
      var mq = window.matchMedia('(min-width:821px)');
      var started = false;
      var io = null;
      var start = function () {
        if (started || !mq.matches) return;
        started = true;
        if (io) io.disconnect();
        crossfadeLoop(aId, bId);
      };
      var nearby = function () {
        var r = frame.getBoundingClientRect();
        return r.top < window.innerHeight + 400 && r.bottom > -400;
      };
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) start(); });
        }, { rootMargin: '400px 0px' });
        io.observe(frame);
      } else if (nearby()) {
        start();
      }
      var onResize = function () { if (mq.matches && nearby()) start(); };
      if (mq.addEventListener) mq.addEventListener('change', onResize);
      else if (mq.addListener) mq.addListener(onResize);
    } catch (e) {}
  }

  /* ---------- révélations au scroll ---------- */

  function armReveal() {
    try {
      var els = document.querySelectorAll('.reveal, .stagger > *');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        for (var i = 0; i < els.length; i++) els[i].classList.add('in');
        return;
      }
      if (!revealIO) {
        revealIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); }
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      }
      for (var j = 0; j < els.length; j++) {
        if (!els[j].classList.contains('in')) revealIO.observe(els[j]);
      }
    } catch (e) {
      try {
        document.querySelectorAll('.reveal, .stagger > *').forEach(function (el) { el.classList.add('in'); });
      } catch (_) {}
    }
  }

  /* ---------- simulateur des quatre critères ---------- */

  function armCriteria() {
    try {
      var track = document.getElementById('gates-track');
      if (!track) return;
      var gates = Array.prototype.slice.call(track.querySelectorAll('.gate'));
      var candEl = document.getElementById('sim-cand');
      var verdictEl = document.getElementById('sim-verdict');

      var getCands = function () { return SIM[lang] || SIM.fr; };
      var resetGates = function () {
        gates.forEach(function (g) { g.classList.remove('pass', 'stop', 'hold', 'skip'); });
      };
      var setVerdict = function (txt, type) {
        if (verdictEl) { verdictEl.textContent = txt; verdictEl.className = 'sim-verdict show ' + type; }
      };
      var clearVerdict = function () {
        if (verdictEl) { verdictEl.textContent = ''; verdictEl.className = 'sim-verdict'; }
      };
      var stopClassFor = function (type) { return type === 'wait' ? 'hold' : 'stop'; };

      // stoppe le cycle précédent (rejoué à chaque changement de langue)
      simOn = false;
      simTimers.forEach(function (t) { clearTimeout(t); });
      simTimers = [];
      var later = function (fn, ms) { simTimers.push(setTimeout(fn, ms)); };

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        var c0 = getCands()[0];
        resetGates();
        gates.forEach(function (g) { g.classList.add('pass'); });
        if (candEl) candEl.textContent = c0.name;
        setVerdict(c0.verdict, 'ok');
        return;
      }

      var STEP = 780, HOLD = 2600;
      simCi = 0;
      var runCand = function () {
        if (!simOn) return;
        var cands = getCands();
        var c = cands[simCi % cands.length];
        resetGates(); clearVerdict();
        if (candEl) candEl.textContent = c.name;
        var last = (c.stop === -1) ? gates.length - 1 : c.stop;
        var t = 640;
        for (var i = 0; i <= last; i++) {
          (function (idx) {
            later(function () {
              if (!simOn) return;
              if (idx === c.stop) {
                gates[idx].classList.add(stopClassFor(c.type));
                for (var j = idx + 1; j < gates.length; j++) gates[j].classList.add('skip');
              } else {
                gates[idx].classList.add('pass');
              }
            }, t);
          })(i);
          t += STEP;
        }
        later(function () { if (simOn) setVerdict(c.verdict, c.type); }, t);
        later(function () { if (simOn) { simCi++; runCand(); } }, t + HOLD);
      };

      if (simIO) simIO.disconnect();
      simIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!simOn) { simOn = true; simCi = 0; runCand(); }
          } else {
            simOn = false;
            simTimers.forEach(function (t) { clearTimeout(t); });
            simTimers = [];
          }
        });
      }, { threshold: 0.3 });
      simIO.observe(track);
    } catch (e) {
      try {
        document.querySelectorAll('#gates-track .gate').forEach(function (g) { g.classList.add('pass'); });
      } catch (_) {}
    }
  }

  /* ---------- démarrage ---------- */

  function init() {
    captureFr();
    try {
      var s = localStorage.getItem('arboron_lang');
      if (s === 'en' || s === 'fr') lang = s;
    } catch (e) {}
    if (lang !== 'fr') applyLang();
    armLangButtons();
    armScroll();
    armHeroVideos('hv3', 'hv4');
    requestAnimationFrame(function () { armReveal(); armCriteria(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
